import {useState} from "react";
// import Image1 from "./img/3Installation de mur tendu imprimé nature et plafond lumineux tendu dans une salle moderne – Unik System Maroc.webp";
import Image2 from "./img/2.webp";
import Image1 from "./img/1.webp";
import Image3 from "./img/3.webp";
import Image4 from "./img/5.webp";
import Image5 from "./img/4.webp";
// import Image from "./img/zz.webp";
import Image6 from "./img/aa.webp";
import gif from "./img/1.gif";


const Bienvenue = () => {
    const [show, setShow] = useState(true);
  return (
    <>
    {/* <div class="ribbon">
  <div class="ribbon-track">
    <span><a className="link-accueil" href="/PlafondsMursTendus"><i className="fa-solid fa-layer-group"></i> Solution Plafonds et Murs Tendus</a></span>
    <span><a className="link-accueil" href="/SolutionAcoustique"><i className="fa-solid fa-volume-low"></i> Solution Acoustique</a></span>
    <span><a className="link-accueil" href="/SolutionLight"><i className="fa-solid fa-lightbulb"></i> Solution Lighting</a></span>
    <span><a className="link-accueil" href="/ProtectionSolaire"><i className="fa-solid fa-sun"></i> Solution Protection Solaire</a></span>
    <span><a className="link-accueil" href="/ArchitectureTextil"><i className="fa-solid fa-compass-drafting"></i> Solution Architecture Textile</a></span>

    <span><a className="link-accueil" href="/PlafondsMursTendus"><i className="fa-solid fa-layer-group"></i> Solution Plafonds et Murs Tendus</a></span>
    <span><a className="link-accueil" href="/SolutionAcoustique"><i className="fa-solid fa-volume-low"></i> Solution Acoustique</a></span>
    <span><a className="link-accueil" href="/SolutionLight"><i className="fa-solid fa-lightbulb"></i> Solution Lighting</a></span>
    <span><a className="link-accueil" href="/ProtectionSolaire"><i className="fa-solid fa-sun"></i> Solution Protection Solaire</a></span>
    <span><a className="link-accueil" href="/ArchitectureTextil"><i className="fa-solid fa-compass-drafting"></i> Solution Architecture Textile</a></span>

    <span><a className="link-accueil" href="/PlafondsMursTendus"><i className="fa-solid fa-layer-group"></i> Solution Plafonds et Murs Tendus</a></span>
    <span><a className="link-accueil" href="/SolutionAcoustique"><i className="fa-solid fa-volume-low"></i> Solution Acoustique</a></span>
    <span><a className="link-accueil" href="/SolutionLight"><i className="fa-solid fa-lightbulb"></i> Solution Lighting</a></span>
    <span><a className="link-accueil" href="/ProtectionSolaire"><i className="fa-solid fa-sun"></i> Solution Protection Solaire</a></span>
    <span><a className="link-accueil" href="/ArchitectureTextil"><i className="fa-solid fa-compass-drafting"></i> Solution Architecture Textile</a></span>

  </div>
</div> */}

    <div className="container-b">
      <div className="title-box">
        <h2 className="h11" aria-label="Solutions intelligentes pour des revetements intelligents">
          <span class="typewriter"></span>
        </h2>
      </div>
      <a href="#Metier"><div className='flecg-icon center'></div></a> 
      <div className="box">
        <div className="bg"></div>
        <img src={Image1} alt="Unik System Maroc" loading="lazy"/>
        <div className="container bg1" id="bgfilma">
      {/* Bouton */}
      <botton
        className="btn-toggle"
        onClick={() => setShow(!show)}
        aria-label="Afficher le contenu"
      >
        <center><img className="gif" src={gif} alt=""/></center>
      </botton>

      {/* Zone de texte */}
      <div className={`bgR ${show ? "show" : ""}`}>
        <p id="ppp">
          Solution <br/>
          Plafonds
        </p>
      </div>
    </div>
        {/* <div className="container bg1" id="bgmur">
          <botton
        className="btn-toggle"
        onClick={() => setShow(!show)}
        aria-label="Afficher le contenu"
      >
        <img className="gif" src={gif} alt="" loading="lazy"/>
      </botton>

      
      <div className={`bgR ${show ? "show" : ""}`}>
        <p id="ppp">
          Solution <br/>
          Murs
        </p>
      </div>
        </div> */}
      </div>
          <div className="box">
        <div className="bg"></div>
        <img src={Image2} alt="" />
        <div className="container bg1" id="bgfilma">
      {/* Bouton */}
      <botton
        className="btn-toggle"
        onClick={() => setShow(!show)}
        aria-label="Afficher le contenu"
      >
        <img className="gif" src={gif} alt="" loading="lazy"/>
      </botton>

      {/* Zone de texte */}
      <div className={`bgR ${show ? "show" : ""}`}>
        <p id="ppp">
          Solution <br/>
          Lighting
        </p>
      </div>
    </div>
      </div>
      <div className="box">
        <div className="bg"></div>
        <img src={Image3} alt="" loading="lazy"/>
        <div className="container bg1" id="bgfilma">
      {/* Bouton */}
      <botton
        className="btn-toggle"
        onClick={() => setShow(!show)}
        aria-label="Afficher le contenu"
      >
        <img className="gif" src={gif} alt="" loading="lazy"/>
      </botton>

      {/* Zone de texte */}
      <div className={`bgR ${show ? "show" : ""}`}>
        <p id="ppp">
          Solution <br/>
          Panneaux acoustiques
        </p>
      </div>
    </div>
      </div>
      <div className="box">
        <div className="bg"></div>
        <img src={Image6} alt="" />
        <div className="container bg1" id="bgfilma">
      {/* Bouton */}
      <botton
        className="btn-toggle"
        onClick={() => setShow(!show)}
        aria-label="Afficher le contenu"
      >
        <img className="gif" src={gif} alt="" loading="lazy"/>
      </botton>

      {/* Zone de texte */}
      <div className={`bgR ${show ? "show" : ""}`}>
        <p id="ppp">
          Solution <br/>
          Art Deco
        </p>
      </div>
    </div>
      </div>
      
      <div className="box">
        <div className="bg"></div>
        <img src={Image4} alt="" />
        <div className="container bg1" id="bgfilm">
      {/* Bouton */}
      <botton
        className="btn-toggle"
        onClick={() => setShow(!show)}
        aria-label="Afficher le contenu"
      >
        <img className="gif" src={gif} alt="" loading="lazy"/>
      </botton>

      {/* Zone de texte */}
      <div className={`bgR ${show ? "show" : ""}`}>
        <p id="ppp">
          Solution <br/>
          Films <br/>solaires
        </p>
      </div>
    </div>
      </div>
      <div className="box">
        <div className="bg"></div>
        <img src={Image5} alt=""  loading="lazy"/>
        <div className="container bg1" id="bgvoile">
      {/* Bouton */}
      <botton
        className="btn-toggle"
        onClick={() => setShow(!show)}
        aria-label="Afficher le contenu"
      >
        <img className="gif" src={gif} alt=""/>
      </botton>

      {/* Zone de texte */}
      <div className={`bgR ${show ? "show" : ""}`}>
        <p id="ppp">
          Solution <br/>
          Voiles <br/>d'ombrages
        </p>
      </div>
    </div>
      </div>
    </div></>
  );
};

export default Bienvenue;
